import { Injectable, inject,OnInit } from '@angular/core';
import { Router, CanActivateFn, CanActivateChildFn, CanMatchFn, ActivatedRoute } from '@angular/router';
import { LocalDataService } from '../services/local-data.service';
import { TwilioHelperService } from 'src/app/shared/services/twilio-helpers.service';



export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);   
   const activatedRoute = inject(ActivatedRoute); 
   const twilioHelper = inject(TwilioHelperService);
   let changePasswordData: any = {};
   changePasswordData.chr = activatedRoute.snapshot.paramMap.get('chr')?.toString();
   changePasswordData.num = activatedRoute.snapshot.paramMap.get('num')?.toString();
   //Id of the role
   changePasswordData.ident = activatedRoute.snapshot.paramMap.get('id')?.toString();
  const localUserData = inject(LocalDataService);
  const userdata = localUserData.getLoginData();
  if ((userdata != null) && (userdata['user']['userID'] != null)) {
    if(state.url.indexOf("/elevator-call-details/CA") != -1)
    {
      return localUserData.getMenuUrls(state.url.indexOf("/elevator-call-details/CA") != -1? "/dashboard": state.url)
    }
    else if(state.url.indexOf("/ongoing-elevator-call") != -1)
    {      
      return localUserData.getMenuUrls(state.url.indexOf("/ongoing-elevator-call") != -1? "/dashboard": state.url)
    }
    else return localUserData.getMenuUrls(state.url);
  }  
  // else if (changePasswordData.chr && changePasswordData.num && changePasswordData.ident) {
  //   return router.navigate(['/login', {}]);
  // }  
  else 
  {
    return router.navigate(['/login']);
  }
};
export const ChildAuthGuard: CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const localUserData = inject(LocalDataService);
  const userdata = localUserData.getLoginData();
  if ((userdata != null) && (userdata['user']['userID'] != null)) {
    return true;
  }
  else {
    router.navigate(['/login']);    
    return false;
  }
};
export const ModuleAuthGuard: CanMatchFn = (route, state) => {
  const router = inject(Router);
  const localUserData = inject(LocalDataService);
  const userdata = localUserData.getLoginData();
  if ((userdata != null) && (userdata['user']['userID'] != null)) {
    return true;
  }
  else {
    router.navigate(['/login']);
    return false;
  }
};

